export enum Loaders {
  GetMspDetailsLoader = 'GetMspDetailsLoader',
  CountriesLoader = 'CountriesLoader',
  MspInviteLoader = 'MspInviteLoader',
  GetAllIPAddressesLoader = 'GetAllIPAddressesLoader',
  GetIPAddressByIdLoader = 'GetIPAddressByIdLoader',
  AddIPAddressLoader = 'AddIPAddressLoader',
  UpdateIPAddressLoader = 'UpdateIPAddressLoader',
  DeleteIPAddressLoader = 'DeleteIPAddressLoader',
  AddProductLoader = 'AddProductLoader',
  AddMemberLoader = 'AddMemberLoader',
  GetColorPaletteLoader = 'GetColorPaletteLoader',
  UpdateCustomColorLoader = 'UpdateCustomColorLoader',
  DeleteCustomColorLoader = 'DeleteCustomColorLoader',
  DisableToggleTagLoader = 'DisableToggleTagLoader',
  DeleteTagLoader = 'DeleteTagLoader',
  PreviewInviteTemplateLoader = 'PreviewInviteTemplateLoader',
  AddPlanLoader = 'AddPlanLoader',
  GetMemberDetailsLoader = 'GetMemberDetailsLoader',
  GetAccessRolesDetailsLoader = 'GetAccessRolesDetailsLoader',
  GetClientAccessDetailsLoader = 'GetClientAccessDetailsLoader',
  GetClientAccessRolesDetailsLoader = 'GetClientAccessRolesDetailsLoader',
  GetCompanySettingsLoader = 'GetCompanySettingsLoader',
  GetToolInfoLoader = 'GetToolInfoLoader',
  GetPracticeToolsByIdLoader = 'GetPracticeToolsByIdLoader',
  UpdateToolLoader = 'UpdateToolLoader',
  RemovePracticeToolLoader = 'RemovePracticeToolLoader',
  GetSecurityStackHeaderViewLoader = 'GetSecurityStackHeaderViewLoader',
  UpdateSecurityStackHeaderViewLoader = 'UpdateSecurityStackHeaderViewLoader',
  GetSecurityStackViewLoader = 'GetSecurityStackViewLoader',
  GetUserDeviceIssuesLoader = 'GetUserDeviceIssuesLoader',
  GetTechnologiesByToolIdLoader = 'GetTechnologiesByToolIdLoader',
  GetPracticeTypesLoader = 'GetPracticeTypesLoader',
  GetAddToolsForStackLoader = 'GetAddToolsForStackLoader',
  GetToolsInMyStackLoader = 'GetToolsInMyStackLoader',
  SaveToolsToMyStackLoader = 'SaveToolsToMyStackLoader',
  RemoveToolFromStackLoader = 'RemoveToolFromStackLoader',
  GetCategoryProductsLoader = 'GetCategoryProductsLoader',
  UpdateStorefrontProductsLoader = 'UpdateStorefrontProductsLoader',
  GetStorefrontProductsLoader = 'GetStorefrontProductsLoader',
  GetCategoriesLoader = 'GetCategoriesLoader',
  UpdateCategoryLoader = 'UpdateCategoryLoader',
  DeleteCategoryLoader = 'DeleteCategoryLoader',
  GetCategoriesSortOrderLoader = 'GetCategoriesSortOrderLoader',
  UpdateCategoriesSortOrderLoader = 'UpdateCategoriesSortOrderLoader',
  GetTechnologySpendLoader = 'GetTechnologySpendLoader',
  GetTechnologySpendForDashboardLoader = 'GetTechnologySpendForDashboardLoader',
  UpdateCategoryVisibilityLoader = 'UpdateCategoryVisibilityLoader',
  ResetCategoriesLoader = 'ResetCategoriesLoader',
  ResetCategoryLoader = 'ResetCategoryLoader',
  UpdateTechSpendCategoryLoader = 'UpdateTechSpendCategoryLoader',
  GetSupplierAndManufacturersLoader = 'GetSupplierAndManufacturersLoader',
  RecalculateServicePackageScoreLoader = 'RecalculateServicePackageScoreLoader',
  RecalculateGovResScoreLoader = 'RecalculateGovResScoreLoader',
  RecalculateServicePackageScoreModalFlagger = 'RecalculateServicePackageScoreModalFlagger',
  RecalculateGovResScoreModalFlagger = 'RecalculateGovResScoreModalFlagger',
  ResetPasswordLoader = 'ResetPasswordLoader',
  ExtendTrialLoader = 'ExtendTrialLoader',
  ConvertSubscriptionLoader = 'ConvertSubscriptionLoader',
}
